module.exports = __webpack_public_path__ + "img/horizontal_3_6_6000.312ea989.png";